module.exports = __webpack_public_path__ + "img/uploading.815cf608.png";